// ---------------------------------------------------------------------------
// Datele de contact, într-un singur loc.
//
// Erau scrise de mână în trei fișiere, iar adresa de email diferea între
// footer (`lermy2013@gmail.com`) și pagina de contact
// (`contact@quantikflow.com`) — vizitatorul vedea altă adresă după ce derula
// până jos. Acum e una singură; se schimbă aici și se schimbă peste tot.
// ---------------------------------------------------------------------------

export const COMPANY_NAME = 'QuantikFlow';
export const COMPANY_LEGAL = 'LERMY S.R.L.';
export const COMPANY_EMAIL = 'contact@quantikflow.com';
export const COMPANY_PHONE = '+40 749 221 917';

// `tel:` nu acceptă spații pe toate telefoanele.
export const phoneHref = `tel:${COMPANY_PHONE.replace(/\s/g, '')}`;
export const mailHref = `mailto:${COMPANY_EMAIL}`;
